import { locales } from './locales.js'

function toOgLocale(iso) {
  return iso.replace('-', '_')
}

export function buildOgLocaleMeta(currentCode = 'fr', excludedCodes = []) {
  const current = locales.find(l => l.code === currentCode) || locales[0]
  const meta = [
    {
      hid: 'og:locale',
      property: 'og:locale',
      content: toOgLocale(current.iso),
    },
  ]
  locales
    .filter(l => l.code !== current.code && !excludedCodes.includes(l.code))
    .forEach(l => {
      meta.push({
        hid: `og:locale:alternate:${l.code}`,
        property: 'og:locale:alternate',
        content: toOgLocale(l.iso),
      })
    })
  return meta
}

export function buildOfferShippingDetails(range, country = 'FR') {
  const rangePrice = range?.price_ttc
  const details = {
    '@type': 'OfferShippingDetails',
    shippingRate: {
      '@type': 'MonetaryAmount',
      value: (typeof rangePrice === 'number' ? rangePrice : 0).toFixed(2),
      currency: 'EUR',
    },
    shippingDestination: {
      '@type': 'DefinedRegion',
      addressCountry: country || 'FR',
    },
  }

  if (typeof range?.delay === 'number' && range.delay > 0) {
    const transitDays = Math.ceil(range.delay / 24)
    details.deliveryTime = {
      '@type': 'ShippingDeliveryTime',
      handlingTime: {
        '@type': 'QuantitativeValue',
        minValue: 0,
        maxValue: 0,
        unitCode: 'DAY',
      },
      transitTime: {
        '@type': 'QuantitativeValue',
        minValue: transitDays,
        maxValue: transitDays,
        unitCode: 'DAY',
      },
    }
  }

  return details
}

export function toJsonLd(data) {
  return JSON.stringify(data).replace(/</g, '\\u003c')
}

export function htmlToPlainText(html) {
  if (!html) return ''
  return html
    .replace(/<br\s*\/?>/gi, ' ')
    .replace(/<\/(p|div|li|ul|ol|h[1-6]|tr)>/gi, ' ')
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&(?:rsquo|apos|#0?39|#x27);/gi, '’')
    .replace(/&(?:ldquo|rdquo|quot|#34);/gi, '"')
    .replace(/&hellip;/gi, '…')
    .replace(/&(?:ndash|mdash);/gi, '–')
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/&amp;/gi, '&')
    .replace(/\s+/g, ' ')
    .trim()
}

export function truncateOnWord(text, maxLength = 320) {
  if (!text || text.length <= maxLength) return text || ''
  const cut = text.slice(0, maxLength)
  const lastSpace = cut.lastIndexOf(' ')
  return `${(lastSpace > 0 ? cut.slice(0, lastSpace) : cut).replace(
    /[\s,;:.–-]+$/,
    ''
  )}…`
}

export function buildOgImageMeta({ url, width = null, height = null, alt }) {
  const meta = [{ hid: 'og:image', property: 'og:image', content: url }]
  if (width) {
    meta.push({
      hid: 'og:image:width',
      property: 'og:image:width',
      content: String(width),
    })
  }
  if (height) {
    meta.push({
      hid: 'og:image:height',
      property: 'og:image:height',
      content: String(height),
    })
  }
  if (alt) {
    meta.push({ hid: 'og:image:alt', property: 'og:image:alt', content: alt })
  }
  meta.push({
    hid: 'twitter:card',
    name: 'twitter:card',
    content: 'summary_large_image',
  })
  meta.push({ hid: 'twitter:image', name: 'twitter:image', content: url })
  if (alt) {
    meta.push({
      hid: 'twitter:image:alt',
      name: 'twitter:image:alt',
      content: alt,
    })
  }
  return meta
}

export const ORGANIZATION_NAME = 'AGM Vision'

export function organizationId(baseUrl) {
  return `${baseUrl}/#organization`
}

export function buildPublisherNode(baseUrl) {
  return {
    '@type': 'Organization',
    '@id': organizationId(baseUrl),
    name: ORGANIZATION_NAME,
    url: baseUrl,
    logo: {
      '@type': 'ImageObject',
      url: `${baseUrl}/logo_og.png`,
    },
  }
}
